import { defineComponent, reactive } from 'vue';
import _ from 'lodash';
import { PopupWrapper } from '@hems/component';
import ModeControl from '@hems/user/src/components/homeAppliance/ModeControl.vue';
import TemperatureControl from '@hems/user/src/components/homeAppliance/TemperatureControl.vue';
export default defineComponent({
    name: 'ApplianceControlPopup',
    components: {
        PopupWrapper,
        TemperatureControl,
        ModeControl,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        controlType: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        supportedModes: {
            type: Object,
            required: true,
        },
    },
    emits: ['save', 'close'],
    setup(props, { emit }) {
        const copyData = _.cloneDeep(props.data);
        const state = reactive({
            data: props.data ? { ...props.data } : null,
            isTemperature: props.controlType === 'temperature',
            isMode: props.controlType === 'mode',
        });
        const onCancel = () => {
            state.data = copyData;
            emit('close');
        };
        const onSave = () => {
            if (state.isTemperature) {
                const params = {
                    commands: [
                        {
                            component: 'main',
                            capability: 'thermostatCoolingSetpoint',
                            command: 'setCoolingSetpoint',
                            arguments: [state.data?.setValue],
                        },
                    ],
                };
                emit('save', params, props.data);
            }
            else if (state.isMode) {
                const params = {
                    commands: [
                        {
                            component: 'main',
                            capability: 'airConditionerMode',
                            command: 'setAirConditionerMode',
                            arguments: [state.data?.mode],
                        },
                    ],
                };
                emit('save', params, props.data);
            }
        };
        return {
            state,
            onSave,
            onCancel,
        };
    },
});
